// source："来源：1.采购推荐 2.线下活动 3.线索 4.商家自主提报 5.未知 6.外贸转内销商"
// entryPoint："填写入口：1.美团app 2.小象app 3.二维码 4.vsspc、 5.微信小程序 、6.小象超市官网、7.未知（历史数据）、8.芥末、9.移动端链接"
// eventName：活动名称
// eventDate：活动日期
export const SOURCE_TYPE = {
    PROCUREMENT_RECOMMENDATION: 1, // 采购推荐
    OFFLINE_ACTIVITY: 2, // 线下活动
    CLUE: 3, // 线索
    MERCHANT_SELF_REPORT: 4, // 商家自主提报
    UNKNOWN: 5,
    FOREIGN_TRADE_TO_DOMESTIC: 6, // 外贸转内销商
};
export const ENTRY_POINT = {
    MEITUAN_APP: 1, // 美团app
    XIAOXIANG_APP: 2, // 小象app
    QR_CODE: 3, // 二维码
    VSSPC: 4, // vsspc
    WECHAT_MINI_PROGRAM: 5, // 微信小程序
    XIAOXIANG_SUPERMARKET: 6, // 小象超市官网
    UNKNOWN: 7, // 未知（历史数据）
    MUSTARD: 8, // 芥末
    MOBILE_LINK: 9, // 移动端链接
};

export function isValidSource(source) {
    return Object.values(SOURCE_TYPE).includes(Number(source));
}
export function isValidEntryPoint(entryPoint) {
    return Object.values(ENTRY_POINT).includes(Number(entryPoint));
}
export function saveSourceParamsToLocalStorage(
    source = '',
    entryPoint = '',
    eventName = '',
    eventDate = '',
) {
    const obj = {
        source: isValidSource(source) ? source : '',
        entryPoint: isValidEntryPoint(entryPoint) ? entryPoint : '',
        eventName: eventName ? decodeURIComponent(eventName) : '',
        eventDate,
    };
    // 将来源参数保存到localStorage
    if (obj.source || obj.entryPoint || obj.eventName || obj.eventDate) {
        localStorage.setItem('sourceParams', JSON.stringify(obj));
    }
}
export function getSourceParamsFromLocalStorage() {
    const params = localStorage.getItem('sourceParams');
    if (!params) return {};

    const {
        source, entryPoint, eventName, eventDate,
    } = JSON.parse(params);
    return {
        source: isValidSource(source) ? source : '',
        entryPoint: isValidEntryPoint(entryPoint) ? entryPoint : '',
        eventName,
        eventDate,
    };
}
/**
 * 获取sessionStorage中的参数
 * ytType: 商业态(10: 自营 20: 联营)
 * hzType: 合作模式(10: 小象 20: 快乐猴)
 * @returns {Object} 参数对象
 */
export function getSourceParamsFromSessionStorage() {
    const params = sessionStorage.getItem('sourceParams');
    if (!params) return {};

    const { ytType, hzType } = JSON.parse(params);
    return {
        ytType,
        hzType,
    };
}
export function clearSourceParams() {
    localStorage.removeItem('sourceParams');
}
